import { IconProps, Icon } from './Icon';

export const CalendarAltIcon = (props: IconProps) => {
  return <Icon name="calendar-alt" {...props} />;
};
